import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Pages:
import { HomePageComponent } from './pages/home-page/home-page.component';
import { ArticlePageComponent } from './pages/article-page/article-page.component';
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { FlyingPageComponent } from './pages/flying-page/flying-page.component';
import { InterprationPageComponent } from './pages/interpration-page/interpration-page.component';
import { AppComponent } from './app.component';



const routes: Routes = [
  {
    path: '', pathMatch: 'prefix', component: AppComponent,
    children:[
      { path: '', component:HomePageComponent, pathMatch:'full' },
      { path: 'article', redirectTo: '', pathMatch: 'full' },
      { path: 'article/:id', component: ArticlePageComponent, pathMatch:'full' },
      { path: 'search', component: SearchPageComponent },
      { path: 'search/:text', component: SearchPageComponent },
      { path: 'fpage/:id', component: FlyingPageComponent },
      { path: 'interpretations', component: InterprationPageComponent, pathMatch:'full'  },
    ],

  },
  { path: 'article/:id', component: ArticlePageComponent, pathMatch:'full' }





];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
